import { Button, EmptyStateBase } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface PeopleAnalyticsEmptyStateProps {
  onChooseField: () => void;
}

export function PeopleAnalyticsEmptyState({ onChooseField }: PeopleAnalyticsEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <EmptyStateBase
      className="py-21 px-3"
      emoji=":juggling:"
      title={t("reporting:people_analytics_empty_group_title")}
      description={t("reporting:people_analytics_empty_group_description")}
      primaryButton={
        <Button onClick={onChooseField}>{t("reporting:people_analytics_choose_field")}</Button>
      }
    />
  );
}
